import React from 'react';
import cx from 'classnames';

import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg';

import styles from './NoteField.module.scss';

interface IProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  maxLength?: number;
}

const NoteField = (props: IProps) => {
  const { value, onChange, placeholder, maxLength = 255 } = props;

  const isCharacterExceed = value.length > maxLength;

  const textareaClassName = cx({
    [styles['textarea']]: true,
    [styles['textarea-error']]: isCharacterExceed,
  });

  const noteLengthClassName = cx({
    [styles['note-length']]: true,
    [styles['note-length-error']]: isCharacterExceed,
  });

  return (
    <>
      <textarea
        className={textareaClassName}
        placeholder={placeholder}
        value={value}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
          onChange(event.target.value)
        }
      />

      <p className={noteLengthClassName}>
        {isCharacterExceed && <ErrorIcon />}

        <span>
          {value.length}/{maxLength} characters
        </span>
      </p>
    </>
  );
};

export default NoteField;
